import { useState } from "react";
import "./EnquiryForm.css";

function EnquiryForm() {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        contactTime: "",
        message: "",
      });

  const [status, setStatus] = useState("");

  function handleChange(event) {
    const { name, value } = event.target;

    setFormData((previousData) => ({
      ...previousData,
      [name]: value,
    }));

    setStatus("");
  }



async function handleSubmit(event) {
    event.preventDefault();
    setStatus("Sending your enquiry...");
  
    try {
      const response = await fetch("https://formspree.io/f/mdeadjjv", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          contactTime: formData.contactTime,
          message: formData.message,
        }),
      });
  
      if (response.ok) {
        setStatus(
          "Thank you! Your enquiry has been submitted. We will contact you soon."
        );
  
        setFormData({
          name: "",
          phone: "",
          email: "",
          contactTime: "",
          message: "",
        });
      } else {
        setStatus(
          "We could not submit your enquiry. Please check the form and try again."
        );
      }
    } catch (error) {
      setStatus(
        "A connection error occurred. Please check your internet connection and try again."
      );
    }
  }
  
  return (
    <section className="enquiry-section" id="enquiry">
      <h2>Enquire About a Property</h2>
      <p>
        Share your details and tell us which property interests you.
      </p>

      <form className="enquiry-form" onSubmit={handleSubmit}>
        <label htmlFor="enquiry-name">Full name</label>
        <input
          id="enquiry-name"
          name="name"
          type="text"
          autoComplete="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="enquiry-phone">Phone number</label>
        <input
          id="enquiry-phone"
          name="phone"
          type="tel"
          autoComplete="tel"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <label htmlFor="enquiry-email">Email address</label>
        <input
          id="enquiry-email"
          name="email"
          type="email"
          autoComplete="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

<label htmlFor="enquiry-contact-time">Preferred contact time</label>
        <select
          id="enquiry-contact-time"
          name="contactTime"
          value={formData.contactTime}
          onChange={handleChange}
          required
        >
          <option value="">Select a preferred time</option>
          <option value="morning">Morning (9 AM – 12 PM)</option>
          <option value="afternoon">Afternoon (12 PM – 4 PM)</option>
          <option value="evening">Evening (4 PM – 7 PM)</option>
          <option value="anytime">Any time</option>
        </select>

        <label htmlFor="enquiry-message">Message</label>
        <textarea
          id="enquiry-message"
          name="message"
          rows="4"
          value={formData.message}
          onChange={handleChange}
        />

        <button type="submit">Submit enquiry</button>

        {status && (
          <p className="enquiry-status" role="status">
            {status}
          </p>
        )}
      </form>
    </section>
  );
}

export default EnquiryForm;